/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Invitation } from '../models/Invitation';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InvitationService {

    /**
     * Create Invitation API Endpoint
     * Create Invitation
     * @param xAccessToken 
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createInvitation(
xAccessToken: string,
requestBody: {
email: string;
userType: string;
comment?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Invitation;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/invitation',
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Get Invitation list API Endpoint
     * Get Invitation list
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @returns any successful operation
     * @throws ApiError
     */
    public static invitationList(
xAccessToken: string,
offset?: number,
limit?: number,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
invitations?: Array<Invitation>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/invitation',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
            },
            errors: {
                400: `Invalid Parameters supplied`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

}
